import BaseMetricCard from "../../../Common/BaseMetricCard";
import { WellnessScoreStatus } from "../../../Common/types";
import { useTranslation } from "react-i18next";
import { getExerciseStatus, getExerciseDisplayValue } from "./utils";

export interface ExerciseCardProps {
  minutesPerWeek: number;
  /** When present (e.g. from health trends API), used as metric display instead of deriving from minutesPerWeek */
  valueDisplayLabel?: string;
  intensity?: "vigorous" | "moderate";
  lastUpdated?: string;
}

const config = {
  translationPrefix: "Exercise",
  analyticsSource: "Health Score - exercise",
  manualEntryRoute: "/home/health-score/lifestyle-questionnaire",
  ctaRoute: "/home/health-score/lifestyle-questionnaire",
};

export default function ExerciseCard(props: ExerciseCardProps) {
  const {
    minutesPerWeek,
    valueDisplayLabel,
    intensity = "vigorous",
    lastUpdated,
  } = props;
  const { t } = useTranslation();

  const status: WellnessScoreStatus = getExerciseStatus(minutesPerWeek);
  const metricValue =
    valueDisplayLabel ?? getExerciseDisplayValue(minutesPerWeek);
  const unit = t(`Exercise.unit.${intensity}` as any);

  return (
    <BaseMetricCard
      metricValue={metricValue}
      status={status}
      lastUpdated={lastUpdated}
      unit={unit}
      config={config}
    />
  );
}
